<div
    class="report-visualization-explore full-height"
    [class.device-desktop]="!isMobile()"
    [class.device-mobile]="isMobile()"
>
    <dsn-tabs [size]="'medium'">
        @for (tab of exploreTabs; track $index) {
            <dsn-tab
                [active]="currentPage === tab.value"
                (click)="onChangePage(tab.value)"
                >{{ tab.label }}
            </dsn-tab>
        }
    </dsn-tabs>

    <div [hidden]="currentPage !== 0" class="full-height">
        @defer {
            <div
                fxLayout="column"
                class="dsn-scrollbar scroll-light page-overflow full-height"
            >
                <ng-container
                    *ngComponentOutlet="
                        drilldownComponent;
                        inputs: {
                            options: report.options,
                            company: company,
                            visualization: visualization,
                            loading: loading,
                            handleSelectVisualization: onVisualizationClick
                        }
                    "
                >
                </ng-container>
            </div>
        }
    </div>

    @if (visualization.tableValues && hasValidData()) {
        <div [hidden]="currentPage !== 1" class="full-height">
            @defer {
                <ng-container
                    *ngComponentOutlet="
                        tableValuesComponent;
                        inputs: {
                            options: report.options,
                            company: company,
                            visualization: visualization
                        }
                    "
                >
                </ng-container>
            }
        </div>
    }

    <div [hidden]="currentPage !== 2" class="full-height">
        @defer {
            <div
                fxLayout="column"
                class="dsn-scrollbar scroll-light page-overflow full-height"
            >
                <ng-container
                    class="full-height"
                    *ngComponentOutlet="
                        aboutVisualizationComponent;
                        inputs: {
                            visualization: visualization
                        }
                    "
                >
                </ng-container>
            </div>
        }
    </div>
</div>
